export default "__VITE_ASSET__Bbqb5Ugh__"